import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import Paper from '@material-ui/core/Paper';
import {Grid} from '@material-ui/core';
import {Add as AddIcon, Remove as RemoveIcon} from '@material-ui/icons';
import {Button} from '@material-ui/core';
import {isEmpty} from 'lodash/lang';
import {PrimaryButton, SecondaryButton} from '../common/StyledButtons';

const QUESTIONS_PER_LISTING = 10;

export default function QuizQuestionList(props){

    const {questionList = [], page, hasNext, fetchData, addQuestionToQuiz, showDetailsModal,
        currentQuestionIds = [], removeQuestionFromQuiz} = props;

    const [lookupId, setLookupId] = React.useState({});

    const quickLookup = React.useMemo(() =>
        currentQuestionIds.reduce((acc, id) => {
            acc[id] = true;
            return acc;
        }, []),[currentQuestionIds]);

    React.useEffect(() =>
        setLookupId(quickLookup),[quickLookup]);

    return (
        <InfiniteScroll
            dataLength={QUESTIONS_PER_LISTING * page}
            next={(args) => fetchData({args,})}
            hasMore={hasNext}
            loader={<p>Loading...</p>}
            scrollableTarget="quiz-list-scrollable-container"
            endMessage={
                <p style={{textAlign: 'center'}}>
                    <b>No more questions to list.</b>
                </p>
            }
        >
            {questionList.map(item => (
                <Paper className="quiz-list-item" key={item._id.$oid}>
                    <p className="quiz-list-item-name">
                        {item.name}
                    </p>
                    <p className="quiz-list-item-content">
                        <span dangerouslySetInnerHTML={{__html:item.content}}/>
                    </p>
                    <p className="quiz-list-item-topic">
                        Topic: {item.topic}
                    </p>
                    {!isEmpty(item.subtopic) &&
                    <p className="quiz-list-item-subtopic">
                        Subtopic: {item.subtopic}
                    </p>
                    }
                    <Grid container>
                        <Grid item xs={3} align="left">
                            <Button
                                onClick={() => showDetailsModal(item)}
                                color="primary" variant="text">
                                Details
                            </Button>
                        </Grid>
                        <Grid item xs={9} align="right">
                            {!lookupId[item._id.$oid] ?
                                <PrimaryButton
                                    size="small"
                                    aria-label="Add to Quiz"
                                    onClick={() => addQuestionToQuiz(item._id.$oid)}>
                                    <AddIcon fontSize="small"/>&nbsp;Add Question
                                </PrimaryButton> :
                                <SecondaryButton
                                    size="small"
                                    aria-label="Remove from Quiz"
                                    onClick={() => removeQuestionFromQuiz(item._id.$oid)}>
                                    <RemoveIcon fontSize="small"/>&nbsp;Remove
                                </SecondaryButton>
                            }
                        </Grid>
                    </Grid>
                </Paper>
            ))}
        </InfiniteScroll>
    );
}
